import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Home.vue'
import LoginView from '@/views/Login.vue'
import ReceiveCode from '@/views/ReceiveCode.vue'
import MailReceive from '@/views/MailReceive.vue'
import ReceiveRecords from '@/views/ReceiveRecords.vue'
import SupportCenterView from '@/views/SupportCenter.vue'
import ContactView from '@/views/Contact.vue'
import MobileAppView from '@/views/MobileApp.vue'
import NotFoundView from '@/views/NotFound.vue'
import FAQView from '@/views/FAQ.vue'
import ApiDocsView from '@/views/ApiDocs.vue'
import ReferralRewardsView from '@/views/ReferralRewards.vue'
import UserCenterView from '@/views/UserCenter.vue'
import InternationalProjectsView from '@/views/InternationalProjects.vue'
import PayVerifyView from '@/views/PayVerify.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { title: '白鲸 - 保护隐私的数据共享平台' }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: '登录/注册 - 白鲸' }
  },
  {
    path: '/receive-code',
    name: 'ReceiveCode',
    component: ReceiveCode,
    meta: { requiresAuth: true, title: '接收数据 - 白鲸' }
  },
  {
    path: '/mail-receive',
    name: 'MailReceive',
    component: MailReceive,
    meta: { requiresAuth: true, title: '邮箱接码 - 白鲸' }
  },
  {
    path: '/receive-records',
    name: 'ReceiveRecords',
    component: ReceiveRecords,
    meta: { requiresAuth: true, title: '收取记录 - 白鲸' }
  },
  {
    path: '/message-processing',
    name: 'MessageProcessing',
    redirect: to => ({
      path: '/tickets',
      query: { ...to.query, tab: 'messages' }
    }),
    meta: { requiresAuth: true, title: '工单中心 - 白鲸' }
  },
  {
    path: '/tickets',
    name: 'TicketCenter',
    component: SupportCenterView,
    meta: { requiresAuth: true, title: '工单中心 - 白鲸' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
    meta: { title: '联系客服 - 白鲸' }
  },
  {
    path: '/mobile-app',
    name: 'MobileApp',
    component: MobileAppView,
    meta: { title: '移动端产品 - 白鲸' }
  },
  {
    path: '/desktop-download',
    name: 'DesktopDownload',
    component: () => import('@/views/DesktopDownload.vue'),
    meta: { title: '桌面端下载 - 白鲸' }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQView,
    meta: { title: '常见问题 - 白鲸' }
  },
  {
    path: '/referral-rewards',
    name: 'ReferralRewards',
    component: ReferralRewardsView,
    meta: { requiresAuth: true, title: '推荐奖励 - 白鲸' }
  },
  {
    path: '/docs',
    name: 'ApiDocs',
    component: ApiDocsView,
    meta: { requiresAuth: true, title: 'API文档 - 白鲸' }
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: UserCenterView,
    meta: { requiresAuth: true, title: '个人中心 - 白鲸' }
  },
  {
    path: '/international-projects',
    name: 'InternationalProjects',
    component: InternationalProjectsView,
    meta: { title: '国际项目列表 - 白鲸' }
  },
  {
    path: '/pay-verify',
    name: 'PayVerify',
    component: PayVerifyView,
    meta: { title: '支付确认 - 白鲸' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView,
    meta: { title: '页面未找到 - 白鲸' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Navigation guards
router.beforeEach((to, from, next) => {
  // Set page title
  document.title = to.meta.title || '白鲸 - 保护隐私的数据共享平台'
  
  // 获取最新的登录状态
  const isLoggedIn = localStorage.getItem('tianqi-token')
  
  // 如果需要登录但用户未登录，则重定向到登录页面
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
